import { minBreakpoints } from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery, stack, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const breadcrumbWrapper = css`
  margin: ${stack(spacing.md)};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin: ${stack(spacing.xxl)};
    `,
  )};
`;
